import * as React from "react";
import { prefetchCurrentUser } from "@/stores/CurrentUser.tsx";
import { useIsLoggedIn } from "@/stores/LoggedInStatus.ts";
import { prefetchPrivacyNotice } from "@/stores/PrivacyNotice.ts";
import { getCvPartner, skipFetchingUser } from "@/util/getCvPartner.ts";
import { Header as ModernHeader } from "./modern/index.tsx";

function useSkipFetchingUser() {
  const isLoggedIn = useIsLoggedIn();

  const [currentPath, setCurrentPath] = React.useState(
    () => window.location.pathname,
  );

  React.useEffect(() => {
    return getCvPartner().subscribeToRouter(() => {
      setCurrentPath(window.location.pathname);
    });
  }, []);

  if (!isLoggedIn) {
    return true;
  }

  return skipFetchingUser(currentPath);
}

export const Header: React.FC = () => {
  const skipFetchingUser = useSkipFetchingUser();

  React.useEffect(() => {
    if (!skipFetchingUser) {
      Promise.all([prefetchCurrentUser(), prefetchPrivacyNotice()]);
    }
  }, [skipFetchingUser]);

  return <ModernHeader />;
};
